import {
  PaginationState, createColumnHelper, flexRender,
  getCoreRowModel, getExpandedRowModel, getSortedRowModel, useReactTable,
} from "@tanstack/react-table";
import DivLoader from "components/divloader/DivLoader";
import React, { useState, useEffect, useContext } from "react";
import { PaymentRowObj } from "..";
import InfoModal from "./InfoModalNew";
import { convertToFloat } from "utils/formatNumber";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import { ClientContext } from "ClientProvider";
import { DownloadFIATCSV } from "api/payouts";
import { toast } from "react-hot-toast";
import ShortTruncateCopy from "components/common/ShortTruncateCopy";
import Searchbox from "components/fields/Searchbox";
import { getImage } from "utils/commonFunction";
import Pagination from "components/pagination";
import StatusRender from "./StatusRender";
import CustomToolTip from "components/tooltips/new";
import { RiArrowUpDownFill } from "react-icons/ri";
import Card from "components/card";
import FilterModal from "./FilterModal";
import { getAllClients } from "api/clients";
import { FaDownload } from "react-icons/fa";

const columnHelper = createColumnHelper<PaymentRowObj>();

function PaymentTable(props: {
  tableData: any; fetchPayments: () => void; filterData: () => void;
  isLoading: boolean; page: number; setPage: any; totalpage: number;
  totalItems: number; currentPage: number; clients: any[]; allGateways: any[];
  allCardType: any[]; curretClient: string; setCurrentClient: any;
  pageSize: number; setPageSize: any; roleData: any; filter: any;
  setFilter: (e: any) => void; onValueChange: (value: string) => void;
  setLocalFilters?: (e: any) => void; setClearClick: () => void;allOrgDetails:any,searchTexts:any
}) {
  const {
    tableData, filterData, fetchPayments, page, clients, allGateways,
    allCardType, setPage, currentPage, totalpage, curretClient,
    setCurrentClient, pageSize, setPageSize, roleData, filter, setFilter,
    onValueChange, setClearClick, setLocalFilters,totalItems,allOrgDetails,searchTexts
  } = props;

  const [{ pageIndex }, setPagination] = React.useState<PaginationState>({ pageIndex: 0, pageSize });
  const { paymentGateway, setPaymentGateway, paymentType, setPaymentType, singleRoleData } = useContext(ClientContext);
  const [DownloadLoading, setDownloadLoading] = useState(false);
  const [data, setData] = React.useState(() => [...(tableData ?? [])]);
  const [subClientsData, setSubClientsData] = useState([]);
  const pagination = React.useMemo(() => ({ pageIndex, pageSize }), [pageIndex, pageSize]);
  const method = roleData[0]?.fiat?.value?.show_fiat_payout_gateway_name;
  const canViewResponseInfo = roleData?.[0]?.fiat?.value?.view_fiat_payout_response_information || roleData?.[0]?.fiat?.value?.view_fiat_payout_gateway_response_information;

  React.useEffect(() => { setData(tableData ?? []); }, [tableData]);

  const handleValueChange = (e: string) => onValueChange(e);

  const buildColumns = (withAction: boolean) => [
    columnHelper.accessor("client_name", {
      id: "client",
      header: () => <span className="fp-th">Client</span>,
      cell: (info: any) => !info.row.getIsExpanded() ? (
        <div className="fp-client-cell">
          <div className="fp-client-avatar">{info.getValue()?.charAt(0)?.toUpperCase() || "?"}</div>
          <span className="fp-client-name">{info.getValue()}</span>
        </div>
      ) : null,
      sortingFn: (rowA, rowB) => {
        const a = rowA.original.client_name || "";
        const b = rowB.original.client_name || "";
        const result = a.localeCompare(b);
        if (result !== 0) {
          return result;
        }
        return String(rowA.original.id).localeCompare(String(rowB.original.id));
      },
    }),
    columnHelper.accessor("created_at", {
      id: "created_at",
      header: () => <span className="fp-th">Date</span>,
      sortDescFirst: true,
      cell: (info) => !info.row.getIsExpanded() ? <span className="fp-date">{info.getValue()}</span> : null,
    }),
    columnHelper.accessor("fiat_amount", {
      id: "fiat_amount",
      header: () => <span className="fp-th">Amount</span>,
      cell: (info: any) => !info.row.getIsExpanded() ? (
        <span className="fp-amount">{convertToFloat(info.getValue())} {info?.row?.original?.fiat_currency}</span>
      ) : null,
      sortingFn: (rowA, rowB) => {
        const a = Number(rowA.original.fiat_amount || 0);
        const b = Number(rowB.original.fiat_amount || 0);
        if (a !== b) {
          return a - b;
        }
        return String(rowA.original.id).localeCompare(
          String(rowB.original.id)
        );
      },
    }),
    columnHelper.accessor("et_id", {
      id: "et_id_",
      header: () => <span className="fp-th">Transaction ID</span>,
      cell: (info) => !info.row.getIsExpanded() ? <ShortTruncateCopy info={info?.getValue()} showCopy /> : null,
      
    }),
    columnHelper.accessor("id", {
      id: "id",
      header: () => <span className="fp-th">Internal ID</span>,
      cell: (info: any) => !info.row.getIsExpanded() ? <ShortTruncateCopy info={info?.getValue()} showCopy /> : null,
    }),
    columnHelper.accessor("gateway_id", {
      id: "gateway_id",
      header: () => <span className="fp-th">Gateway {method ? "Name" : "Hash ID"}</span>,
      cell: (info) => !info.row.getIsExpanded() ? (
        !singleRoleData[0]?.fiat?.value?.show_fiat_payout_gateway_name
          ? <ShortTruncateCopy info={info?.cell?.row?.original?.gateway_id || "—"} showCopy />
          : <div className="fp-gateway-cell">
              <img style={{ height:"auto", width:"14px" }} src={getImage(info?.cell?.row?.original?.gateway_name)} alt="" />
              <span className="fp-gateway-name">{info?.cell?.row?.original?.gateway_name || "—"}</span>
            </div>
      ) : null,
      enableSorting: true, 
      sortingFn: (rowA, rowB) => {
        const a = rowA.original.gateway_id || "";
        const b = rowB.original.gateway_id || "";
        const result = a.localeCompare(b);
        if (result !== 0) {
          return result;
        }
        return String(rowA.original.id).localeCompare(String(rowB.original.id));
      },
    }),
    columnHelper.accessor("meta_info.Descriptor" as any, {
      id: "descriptor",
      header: () => <span className="fp-th">Descriptor</span>,
      cell: (info: any) => !info.row.getIsExpanded() ? <span className="fp-descriptor">{info.row.original.meta_info?.Descriptor || "—"}</span> : null,
      enableSorting: true,
      sortingFn: (rowA, rowB) => {
        const a = rowA.original.meta_info?.Descriptor || "";
        const b = rowB.original.meta_info?.Descriptor || "";
        const result = a.localeCompare(b);
        if (result !== 0) {
          return result;
        }
        return String(rowA.original.id).localeCompare(String(rowB.original.id));
      },
    }),
    columnHelper.accessor("status", {
      id: "status",
      header: () => <span className="fp-th">Status</span>,
      cell: (info) => !info.row.getIsExpanded() ? (
        <CustomToolTip
          content={info?.row?.original?.payment_history?.length > 0
            ? info?.row?.original?.payment_history?.map((h: any, i: number) => (
                <Card className="m-2 shadow" key={i}>
                  <div className="border border-white p-3 max-w-[60vh]">
                    <p>{i === 0 ? `Created at ${h?.created_at} by API call from [${h?.client} - ${h?.ip}] with status ${h?.status}` : `Status change from ${h?.previous_status} to ${h?.status} at ${h?.status_changed_date}`}</p>
                  </div>
                </Card>
              ))
            : <span>No history available.</span>
          }
          trigger={<button className="fp-status-btn"><StatusRender status={info?.row?.original?.status} value={info.getValue()} /></button>}
          header="Status History"
        />
      ) : null,
      sortingFn: (rowA, rowB) => {
        const a = rowA.original.status || "";
        const b = rowB.original.status || "";
        const result = a.localeCompare(b);
        if (result !== 0) {
          return result;
        }
        return String(rowA.original.id).localeCompare(String(rowB.original.id));
      },
    }),
    ...(withAction ? [columnHelper.accessor("et_id", {
      id: "et_id",
      header: () => <span className="fp-th">Actions</span>,
      cell: (info: any) => !info.row.getIsExpanded() ? (
        <div className="fp-actions">
          {canViewResponseInfo && <InfoModal info={info.row.original} />}
        </div>
      ) : null,
      enableSorting: false,
    })] : []),
  ];

  const columns = buildColumns(true);
  const columnsNonAction = buildColumns(false);

  const table = useReactTable({
    data,
    // columns: roleData?.[0]?.fiat?.value?.view_fiat_payout_response_information ? columns : columnsNonAction,
    columns: buildColumns(canViewResponseInfo),
    state: { pagination },
    onPaginationChange: setPagination,
    getSubRows: (row) => row.all_data,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
  });

  const getSubClientsData = () => {
        getAllClients(0)
        .then((data) => setSubClientsData(data[0]))
        .catch((err) => toast.error(err?.response?.data?.message ?? "Something went wrong while fetching clients"))
        .finally(() => {  });
    };
    
    React.useEffect(() => { getSubClientsData(); }, []);
 
  const handelOnDownloadCSV = () => {
    setDownloadLoading(true);
    DownloadFIATCSV(filter?.status, filter?.clients, filter?.gateways, filter?.dates?.[0], filter?.dates?.[1],searchTexts)
      .then((response) => {
        const blob = new Blob([response], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob); link.download = "fiat-payouts.csv";
        document.body.appendChild(link); link.click(); document.body.removeChild(link);
        toast.success("Download Completed"); setTimeout(() => setDownloadLoading(false), 2000);
      })
      .catch(() => { toast.error("Download failed"); setTimeout(() => setDownloadLoading(false), 2000); });
  };

  const resetRow = () => {
    
  }

  return (
    <div className="fp-table-card">
      <div className="fp-table-header">
        <div className="fp-table-header-left">
          <div className="fp-table-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
            </svg>
          </div>
          <div>
            <h3 className="fp-table-title">Single Payouts</h3>
            {/* <p className="fp-table-sub">Individual fiat payout transactions</p> */}
            <p className="fp-table-sub">{totalItems > 0 ? `${totalItems.toLocaleString()} total transaction${totalItems !== 1 ? "s" : ""}` : "No transactions"}</p>

          </div>
        </div>
        <div className="fp-table-header-right">
          <button
            className="txn-download-btn"
            onClick={handelOnDownloadCSV}
            disabled={DownloadLoading || table.getRowModel().rows.length === 0}
          >
            {DownloadLoading ? <span className="txn-btn-spinner" /> : <FaDownload size={12} />}
            <span>Export CSV</span>
          </button>
          <FilterModal
            subClientsData={subClientsData} setPage={props.setPage}
            filter={filter} setFilter={setFilter} roleData={roleData}
            setClearClick={setClearClick} 
            fetchAllsettlement={filterData}
            allOrgDetails={allOrgDetails}
            filterData={filterData}
            resetRow= {resetRow}
            setPageSize={setPageSize}
          />
          <Searchbox onSearch={handleValueChange} />
        </div>
      </div>

      <div className="fp-table-wrap">
        {props.isLoading ? (
          <div className="fp-loading"><div className="fp-spinner" /><p className="fp-loading-txt">Loading payouts…</p></div>
        ) : (
          <table className="fp-table">
            <thead>
              {table.getHeaderGroups().map((hg) => (
                <tr key={hg.id}>
                  {hg.headers.map((h) => (
                    <th key={h.id} colSpan={h.colSpan}
                      onClick={h.column.getToggleSortingHandler()}
                      className={`fp-thead-th${h.column.getCanSort() ? " fp-thead-th--sort" : ""}`}
                    >
                      <div className="fp-th-inner">
                        {flexRender(h.column.columnDef.header, h.getContext())}
                        {h.column.getCanSort() && (
                          <span className="fp-sort-icon">
                            {h.column.getIsSorted() === "asc" ? <BsArrowUp size={11} /> :
                             h.column.getIsSorted() === "desc" ? <BsArrowDown size={11} /> :
                             <RiArrowUpDownFill size={11} />}
                          </span>
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.length > 0 ? (
                table.getRowModel().rows.map((row, ri) => (
                  <tr key={row.id} className={`fp-tbody-tr${ri % 2 !== 0 ? " fp-tbody-tr--alt" : ""}`}>
                    {row.getVisibleCells().map((cell, ci) => (
                      <td key={ci} className="fp-tbody-td">
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr><td colSpan={10}>
                  <div className="fp-empty">
                    <div className="fp-empty-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg></div>
                    <p className="fp-empty-title">No payouts found</p>
                    <p className="fp-empty-sub">Try adjusting your filters</p>
                  </div>
                </td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      <div className="fp-pagination-wrap">
        <Pagination setPage={setPage} page={page} totalpage={totalpage} currentPage={currentPage} pageSize={pageSize} setPageSize={setPageSize} arraySize={[50, 100, 200]} />
      </div>

      {FP_TABLE_STYLES}
    </div>
  );
}

export default PaymentTable;

export const FP_TABLE_STYLES = (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
    .fp-table-card { font-family:'Plus Jakarta Sans',sans-serif; background:#fff; border:1px solid #e2e8f0; border-radius:18px; overflow:hidden; box-shadow:0 2px 8px rgba(15,23,42,.06); }
    .fp-table-header { padding:15px 20px 12px; border-bottom:1px solid #f1f5f9; display:flex; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap; }
    .fp-table-header-left { display:flex; align-items:center; gap:10px; }
    .fp-table-icon { width:36px; height:36px; border-radius:10px; background:linear-gradient(135deg,#eff6ff,#dbeafe); border:1.5px solid #bfdbfe; display:flex; align-items:center; justify-content:center; color:#2563eb; flex-shrink:0; }
    .fp-table-title { font-size:14px; font-weight:700; color:#0f172a; letter-spacing:-.2px; margin-bottom:1px; line-height:20px; }
    .fp-table-sub { font-size:11.5px; color:#94a3b8; font-weight:500; }
    .fp-table-header-right { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }
    .fp-table-wrap { overflow-x:auto; }
    .fp-table-wrap::-webkit-scrollbar { height:3px; }
    .fp-table-wrap::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }
    .fp-table { width:100%; border-collapse:collapse; }
    .fp-thead-th { padding:9px 12px 8px; background:#f8fafc; border-bottom:1.5px solid #e2e8f0; text-align:left; white-space:nowrap; user-select:none; }
    .fp-thead-th--sort { cursor:pointer; }
    .fp-thead-th--sort:hover { background:#f1f5f9; }
    .fp-th-inner { display:flex; align-items:center; gap:4px; }
    .fp-th { font-size:10.5px; font-weight:700; color:#374151; text-transform:uppercase; letter-spacing:.4px; }
    .fp-sort-icon { color:#b0bec5; display:flex; align-items:center; flex-shrink:0; }
    .fp-tbody-tr { transition:background .1s; }
    .fp-tbody-tr:hover { background:#f8faff; }
    .fp-tbody-tr--alt { background:#fafbfc; }
    .txn-download-btn { display:inline-flex; align-items:center; gap:6px; font-family:'Plus Jakarta Sans',sans-serif; font-size:13px; font-weight:700; color:#fff; padding:9px 16px; border-radius:10px; border:none; background:linear-gradient(135deg,#1d4ed8,#2563eb); cursor:pointer; box-shadow:0 3px 10px rgba(37,99,235,.24); transition:all .15s; white-space:nowrap; }
    .txn-download-btn:hover:not(:disabled) { transform:translateY(-1px); box-shadow:0 6px 18px rgba(37,99,235,.32); }
    .txn-download-btn:disabled { opacity:.5; cursor:not-allowed; transform:none; }
    .fp-tbody-td { padding:8px 12px; border-bottom:1px solid #f1f5f9; vertical-align:middle; }
    .fp-client-cell { display:flex; align-items:center; gap:6px; }
    .fp-client-avatar { width:24px; height:24px; border-radius:6px; background:linear-gradient(135deg,#eff6ff,#dbeafe); border:1.5px solid #bfdbfe; display:flex; align-items:center; justify-content:center; font-size:9.5px; font-weight:800; color:#2563eb; flex-shrink:0; }
    .fp-client-name { font-size:12px; font-weight:600; color:#0f172a; white-space:nowrap; }
    .fp-date { font-size:11.5px; font-weight:500; color:#334155; white-space:nowrap; }
    .fp-amount { font-size:12.5px; font-weight:700; color:#0f172a; white-space:nowrap; text-transform:uppercase; }
    .fp-gateway-cell { display:flex; align-items:center; gap:6px; }
    .fp-gateway-name { font-size:12px; font-weight:600; color:#0f172a; white-space:nowrap; }
    .fp-descriptor { font-size:12px; font-weight:500; color:#475569; white-space:nowrap; }
    .fp-status-btn { background:none; border:none; cursor:pointer; padding:0; display:inline-flex; align-items:center; }
    .fp-actions { display:flex; align-items:center; gap:4px; }
    .fp-loading { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:48px; gap:12px; }
    .fp-spinner { width:26px; height:26px; border:3px solid #e2e8f0; border-top-color:#2563eb; border-radius:50%; animation:fpSpin .7s linear infinite; }
    @keyframes fpSpin { to{transform:rotate(360deg)} }
    .fp-loading-txt { font-size:12.5px; color:#94a3b8; font-weight:500; }
    .fp-empty { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:48px 24px; gap:10px; }
    .fp-empty-icon { width:48px; height:48px; border-radius:12px; background:#f8fafc; border:1.5px solid #e2e8f0; display:flex; align-items:center; justify-content:center; color:#cbd5e1; }
    .fp-empty-title { font-size:13.5px; font-weight:700; color:#64748b; }
    .fp-empty-sub { font-size:12px; color:#94a3b8; font-weight:500; text-align:center; }
    .fp-pagination-wrap { padding:10px 14px; border-top:1px solid #f1f5f9; background:#fafbfc; }
    @media (max-width:700px) { .fp-table-header { flex-direction:column; align-items:flex-start; } .fp-table-header-right { width:100%; } }
  `}</style>
);